"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotGetAccessToken = exports.ErrorNotGetUserId = void 0;
exports.ErrorNotGetUserId = {
    code: -1,
    message: "Not get userId. May not login or not implement getUserId in getTradeDependencyInstance",
};
exports.ErrorNotGetAccessToken = {
    code: -1,
    message: "Not get access token. May not login or not implement getAccessToken in getTradeDependencyInstance",
};
